import { render, staticRenderFns } from "./ArtistBanner.vue?vue&type=template&id=7bece813&scoped=true&"
import script from "./ArtistBanner.vue?vue&type=script&lang=js&"
export * from "./ArtistBanner.vue?vue&type=script&lang=js&"
import style0 from "./ArtistBanner.vue?vue&type=style&index=0&id=7bece813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bece813",
  null
  
)

export default component.exports